import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandSelectClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M5.25,5.25c0,-2.347 1.903,-4.25 4.25,-4.25v0c2.347,0 4.25,1.903 4.25,4.25" }),
			/* @__PURE__ */ _jsx("path", { d: "M14,12v-1.75c0,-0.828 -0.672,-1.5 -1.5,-1.5v0c-0.828,0 -1.5,0.672 -1.5,1.5" }),
			/* @__PURE__ */ _jsx("path", { d: "M14,11.25c0,-0.828 0.672,-1.5 1.5,-1.5v0c0.828,0 1.5,0.672 1.5,1.5v1.75" }),
			/* @__PURE__ */ _jsx("path", { d: "M11,12v-6.75c0,-0.828 -0.672,-1.5 -1.5,-1.5v0c-0.828,0 -1.5,0.672 -1.5,1.5v8.75l-1.884,-1.884c-0.616,-0.616 -1.616,-0.616 -2.232,0v0c-0.514,0.514 -0.594,1.319 -0.191,1.924l3.526,5.288c1.113,1.669 2.986,2.672 4.992,2.672h1.789c3.314,0 6,-2.686 6,-6v-3.75c0,-0.828 -0.672,-1.5 -1.5,-1.5v0c-0.828,0 -1.5,0.672 -1.5,1.5" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgHandSelectClick;
